import * as Sentry from '@sentry/react';

export const errorHandler = (error, context = {}, level = 'error') => {
  // Enhanced error logging with context
  console.error('Error occurred:', {
    error: error.message || error,
    stack: error.stack,
    context,
  });

  // Send to Sentry with context
  Sentry.withScope((scope) => {
    scope.setLevel(level);
    if (context.user) scope.setUser(context.user);
    if (context.tags) {
      Object.entries(context.tags).forEach(([key, value]) => {
        scope.setTag(key, value);
      });
    }
    if (context.extra) scope.setContext('extra', context.extra);

    Sentry.captureException(error);
  });
};

// Backward compatibility
export const errorHander = errorHandler;

export const logError = (message, error = null, context = {}) => {
  const errorObj = error || new Error(message);
  errorHandler(errorObj, { ...context, message }, 'error');
};

export const logWarning = (message, context = {}) => {
  console.warn('Warning:', message, context);
  Sentry.addBreadcrumb({
    message,
    level: 'warning',
    data: context,
  });
};

export const logInfo = (message, context = {}) => {
  console.info('Info:', message, context);
  Sentry.addBreadcrumb({
    message,
    level: 'info',
    data: context,
  });
};
